import { put, call, takeLatest } from 'redux-saga/effects';
import * as APICommon from '../../services/apiCommon';
import * as SagaCommon from '../../sagas/sagasCommon';

import { 
  GET_ENTITY_PURCHASE_ORDERS,
  GET_ENTITY_PURCHASE_ORDERS_IN_PROGRESS,
  SET_ENTITY_PURCHASE_ORDER_LIST
 } from '../../constants/constant_action_types';

 import {
  setPurchaseOrderPagination
 } from '../../actions/actionCreatorEntityPurchase';

export function* getEntityPurchaseOrdersSaga(feathersApp) {
  yield takeLatest(GET_ENTITY_PURCHASE_ORDERS, callGetEntityPurchaseOrders, feathersApp);
}

function* callGetEntityPurchaseOrders(feathersApp, action) {
  try {
    const { filters = {} } = action;

    yield put({ type: GET_ENTITY_PURCHASE_ORDERS_IN_PROGRESS });
    const dataParams = {
      filters: { ...filters },
      list_type: 'purchase_order'
    };

    const entityPurchaseOrderResult = yield call(APICommon.getListData, feathersApp, dataParams);

    let entityPurchaseOrders = entityPurchaseOrderResult.docs;

    yield put(setPurchaseOrderPagination(null, null, entityPurchaseOrderResult.total));
    yield put({ type: SET_ENTITY_PURCHASE_ORDER_LIST, list: entityPurchaseOrders });

  } catch (error) {
    yield SagaCommon.showErrorListTable(error);
  }
}